// candidates.ts — Patch 010.A.4 R7 split. Candidate review (approve / reject /
// edit / defer) per Patch 007 candidate-review chassis.

import { request } from './request'
import type {
  ApproveOptions,
  ApproveResult,
  CandidateRow,
  CandidateStatus,
  TriggeredJson,
} from './types'

export const candidatesApi = {
  list: (projectId: string) =>
    request<{ ok: true; lane_b_enabled: boolean; candidates: CandidateRow[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/candidates`,
    ),
  approve: (projectId: string, candidateId: string, body: ApproveOptions) =>
    request<{ ok: true; result: ApproveResult }>(
      `/api/projects/${encodeURIComponent(projectId)}/candidates/${encodeURIComponent(
        candidateId,
      )}/approve`,
      { method: 'POST', body: JSON.stringify(body ?? {}) },
    ),
  reject: (
    projectId: string,
    candidateId: string,
    body: { reasonCode: string; reasonDetail?: string | null },
  ) =>
    request<{ ok: true }>(
      `/api/projects/${encodeURIComponent(projectId)}/candidates/${encodeURIComponent(
        candidateId,
      )}/reject`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  edit: (
    projectId: string,
    candidateId: string,
    body: { linkedProjectAreaId?: string | null; status?: CandidateStatus; triggeredJsonPatch?: Partial<TriggeredJson> },
  ) =>
    request<{ ok: true; candidate: CandidateRow }>(
      `/api/projects/${encodeURIComponent(projectId)}/candidates/${encodeURIComponent(
        candidateId,
      )}/edit`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  defer: (
    projectId: string,
    candidateId: string,
    body: { returnByDate?: string; notes?: string },
  ) =>
    request<{ ok: true }>(
      `/api/projects/${encodeURIComponent(projectId)}/candidates/${encodeURIComponent(
        candidateId,
      )}/defer`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
}
